import React, { memo } from "react";
import { ServiceInformations } from "../../types/serviceDetail";

interface Props {
  serviceInformations: ServiceInformations[];
  sectionTitle: string | null;
  line: string | null;
  isPage?: boolean;
}

const ServiceInformationItem: React.FC<{
  options: ServiceInformations;
  isPage: boolean;
}> = memo(({ options, isPage }) => {
  const { info_icon, info_label, info_description } = options;

  return (
    <div className="col-md-3 col-6 px-1 mb-3 mb-md-0">
      <div className="visa-information">
        <div className="bg-white visa-in-wrap">
          <img
            src={info_icon || "/default-icon.png"} // Default icon if missing
            alt={info_label || "Info label"}
            className="d-block mx-auto"
          />
        </div>
        {isPage ? (
          <h3 className="mb-1 mt-2 font-14 text-grey ff-normal mb-3">
            {info_label || "No label available"}
          </h3>
        ) : (
          <p className="mb-1 mt-2 font-10 text-grey ff-normal">
            {info_label || "No label available"}
          </p>
        )}
        <p className="mb-1 font-10 ff-bold text-black">
          {info_description || "No description available"}
        </p>
      </div>
    </div>
  );
});

const ServiceInformation: React.FC<Props> = ({
  serviceInformations,
  sectionTitle,
  line,
  isPage = false,
}) => {
  return (
    <div className="applicable-main-wrap py-4">
      {sectionTitle && (
        <>
          {isPage ? (
            <h2
              className="text-center font-16 text-black ff-semibold mb-4"
              dangerouslySetInnerHTML={{ __html: sectionTitle }}
            />
          ) : (
            <p
              className="text-center font-16 text-black ff-semibold mb-4"
              dangerouslySetInnerHTML={{ __html: sectionTitle }}
            />
          )}
        </>
      )}
      {line && (
        <p className="font-12 text-grey ff-normal text-center">{line}</p>
      )}

      <div className="container-fluid ">
        <div className="row">
          {serviceInformations.map((options, index) => (
            <ServiceInformationItem
              key={index}
              options={options}
              isPage={isPage}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default memo(ServiceInformation);
